import Tasks from 'APP/Tasks';
import Entities from 'STORE';
import { VoicePayload } from 'STORE/Messages/Message/Payload/VoicePayload/VoicePayload';

export async function createVoiceMessage(groupId: string): Promise<boolean> {
  const inputPanel = Entities.InputPanelsStore.getById(groupId);
  if (!inputPanel) {
    return false;
  }

  if (inputPanel.voice.isRecording) {
    await inputPanel.voice.stop();
  }

  const data = await inputPanel.voice.getVoiceData();
  const payload = new VoicePayload({
    fileName: data.file.name,
    fileSize: data.file.size,
    mimeType: data.file.type,
    userFile: data.file,
    duration: data.duration,
    histogram: data.histogram,
  });

  const canSend = Tasks.messaging.canSendMessage({ groupId, payload });
  if (!canSend.result) {
    canSend.error && Tasks.app.showToast(canSend.error);
    return false;
  }

  await Tasks.messaging.createNewMessages(groupId, [
    {
      payload,
      repliedMessage: inputPanel.replyMessage || undefined,
      quote: inputPanel.quote || undefined,
    },
  ]);

  return true;
}
